import { cn } from '@/lib/utils';

interface LogoMarkProps {
  /** Rendered width/height in px. */
  size?: number;
  className?: string;
}

/**
 * KundaliAI logo mark — renders the brand logo (public/logo-96.webp, derived
 * from public/kundaliai-logo.png, which is also the source for all
 * favicon/PWA icons via scripts/generate-pwa-icons.mjs).
 *
 * The artwork is a self-contained emblem (gold zodiac ring + lotus) on
 * transparency and is bright enough to sit on the dark chrome unaided, so it
 * carries no container ring or glow.
 */
export function LogoMark({ size = 24, className }: LogoMarkProps) {
  return (
    <img
      src="/logo-96.webp"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={cn('inline-block shrink-0', className)}
    />
  );
}
